import React, { useEffect, useState, useRef } from "react";
import TopBreadcrumbs from "../../Settings/Surcharge/TopBreadcrumbs";
import { additionalChargesBookingBreadcrumb, instantRateApplyBidBookingBreadcrumb, instantRateBookingBreadcrumb } from "../../../common/data/parties";
import { Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import ShippingQuotationForm from "./components/ShippingQuotationForm";
import classnames from "classnames";
import {
    ADD_OBJECT_INSTANT_SEARCH, FILTER_INSTANT_RATE,
    GET_AIR_LOCATION_TYPE,
    INSTANT_RATE_ACTIVE_TAB_TYPE,
    REMOVE_OBJECT_INSTANT_SEARCH, SEARCH_RESULT_FILTER_UPDATE, SMART_QUOTATION_VALUE_UPDATE
} from "../../../store/InstantRate/actionType";
import Select from "react-select";
import { filter_icon } from "../../../assets/images";
import { useDispatch, useSelector } from "react-redux";
import FilterSearchResult from "../../Sales/partials/FilterSearchResult";
import { inputArr } from "../OceanFreightResult/SearchResultComp";
import { useLocation, useNavigate } from "react-router-dom";
import PreviewQuotationModal from "../Preview/PreviewQuotationModal";
import moment from "moment/moment";
import { filterInstantSearchAction } from "../../../store/InstantRate/actions";
import TourGuide from "../../../components/Common/TourGuide/TourGuide";
import AirQuotationForm from "./components/AirQuotationForm";
import { QUOTE_MODAL_INITIAL } from "../../../store/Sales/Quotation/actiontype";

const CreateSmartQuotation = () => {
    const [currentQuotationId, setCurrentQuotationId] = useState(null);
    const { activeQuotationsViewDetails } = useSelector((state) => state?.sales);
    const { currency_data } = useSelector((state) => state?.globalReducer);
    const [isRight, setIsRight] = useState(false);
    const [filterLoader, setFilterLoader] = useState(false);
    const [filterDetails, setfilterDetails] = useState(inputArr);
    const [carriersList, setCarriersList] = useState([]);
    const [globalCurrency, setGlobalCurrency] = useState({ label: 'INR', value: 'rupee', currencyCode: "INR", id: 2, version: 0 })
    const dispatch = useDispatch();

    const [previewModal, setPreviewModal] = useState(false);
    const [quoteModal, setQuoteModal] = useState(false);
    const navigateState = useLocation();
    const [isApplyBids, setIsApplyBids] = useState(false);
    const [isShipper, setIsShipper] = useState(true);
    // Add state for active tab
    const [activeTab, setActiveTab] = useState("OCEAN_FCL");
    // Add state to track if initial setup is complete
    const [initialSetupComplete, setInitialSetupComplete] = useState(false);
    const [rateType, setRateType] = useState();
    const [isAdditionalBooking, setIsAdditionalBooking] = useState(false);

    // Create a ref to store the reloadCharges function from ShippingQuotationForm
    const reloadChargesRef = useRef(null);
    // Pre-populate with the current quotation or use default values
    const airReloadChargesRef = useRef(null);

    const handleChangeMovementType = (type) => {
        setIsShipper(type);
    }

    // This effect runs first to set up the initial state
    useEffect(() => {
        //console.log("Initial setup effect running");
        if (navigateState?.state?.data !== undefined) {
            //console.log(navigateState?.state, "navigateState?.state CreateSmartQuotation");
            setRateType(navigateState?.state?.data?.rateType)
            setActiveTab(navigateState?.state?.data?.rateType);
            setIsApplyBids(true);
            if(navigateState?.state?.locationFrom === 'bookingLeads') {
                setIsApplyBids(false);
                setIsAdditionalBooking(true);
            }
        }
        // Mark initial setup as complete
        setInitialSetupComplete(true);
    }, [navigateState]);

    useEffect(() => {
        if (activeQuotationsViewDetails != null && activeQuotationsViewDetails?.movementType !== null) {
            setIsShipper(activeQuotationsViewDetails?.movementType === "EXPORT" ? true : false);
        }
    }, [activeQuotationsViewDetails])

    const quotationData = {};

    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    };

    const applyFilterHandler = () => {
        //console.log(filterDetails, "filterDetails after hit");
        dispatch({ type: SMART_QUOTATION_VALUE_UPDATE, payload: { "filterDetails": filterDetails } });

        // dispatch({ type: FILTER_INSTANT_RATE, payload: filterDetails });
        //
        // let carrierIds = instantSearchResultCopy?.map((item) => {
        //     if (filterDetails?.carriers?.includes(item.carrierName)) {
        //         return item.carrierId
        //     }
        // }).filter(Boolean);
        // let uniqueCarrierId = carrierIds.filter((value, index, self) => self.indexOf(value) === index);
        //
        // let startDate = filterDetails?.validity[0] !== undefined ? moment(filterDetails?.validity[0]).format('YYYY-MM-DD') : '';
        // let endDate = filterDetails?.validity[1] !== undefined ? moment(filterDetails?.validity[1]).format('YYYY-MM-DD') : '';
        //
        // let url = '?'
        // if (uniqueCarrierId.length > 0 || startDate || endDate || activeTab) {
        //     if (uniqueCarrierId.length > 0) {
        //         url += `carriers=${uniqueCarrierId}&`;
        //     }
        //     if (startDate !== '') {
        //         url += `startDate=${startDate}&`;
        //     }
        //     if (endDate !== '') {
        //         url += `endDate=${endDate}&`;
        //     }
        //     if (activeTab !== '') {
        //         url += `ordering=${activeTab === 'preferred' ? 'PREFERRED' : activeTab === 'cheaper' ? 'CHEAPEST' : activeTab === 'faster' ? 'FASTEST' : 'DEFAULT'}&`;
        //     }
        //
        //     url += `fclInquiryDetailId=${instantInquiryId}`;
        // }
        // dispatch(filterInstantSearchAction(url));
        //
        // setTimeout(() => {
        //     dispatch({ type: SEARCH_RESULT_FILTER_UPDATE, payload: { obj: filterDetails?.charges } });
        //     setIsRight(false);
        // }, 1000);

    }

    const clearValueHandler = () => {
        // setFilterLoader(true);
        setfilterDetails(inputArr);
        dispatch({ type: SMART_QUOTATION_VALUE_UPDATE, payload: { "filterDetails": inputArr } });
    }

    const previewModalHand = () => {
        setPreviewModal(!previewModal);
    }

    function QuoteModalHandler() {
        setQuoteModal(!quoteModal);
    }

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <TourGuide>
                        <TopBreadcrumbs breadcrumbs={isAdditionalBooking ? additionalChargesBookingBreadcrumb : (isApplyBids ? instantRateApplyBidBookingBreadcrumb : instantRateBookingBreadcrumb) } tourAdress={"smartQuotation"} />
                        <Row className="mb-4 align-items-center">
                            <Col md={6}>
                                <div className="toggle-container mb-1">
                                    <div
                                        className={`toggle-option ${isShipper ? 'active' : ''}`}
                                        onClick={() => handleChangeMovementType(true)}>
                                        Export
                                    </div>
                                    <div
                                        className={`toggle-option ${!isShipper ? 'active' : ''}`}
                                        onClick={() => handleChangeMovementType(false)}>
                                        Import
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div className="create_sales_wrapper instant_rate_wrapper">
                            <div className="create_sales_wrapper_inner">
                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                                    {/* Tabs on the left */}
                                    <Nav className="nav-tabs-custom card-header-tabs border-bottom mb-0">
                                        <NavItem>
                                            <NavLink
                                                href="#"
                                                className={classnames({
                                                    "active px-3 py-2": activeTab === "OCEAN_FCL",
                                                    "px-3 py-2": activeTab !== "OCEAN_FCL"
                                                })}
                                                onClick={() => {
                                                    dispatch({ type: QUOTE_MODAL_INITIAL });
                                                    setActiveTab("OCEAN_FCL");
                                                    dispatch({ type: INSTANT_RATE_ACTIVE_TAB_TYPE, payload: { main: "international", sub: "FCL" } });
                                                    dispatch({ type: REMOVE_OBJECT_INSTANT_SEARCH, payload: 'shipment_details' });
                                                    // Call reloadCharges function if available
                                                    if (reloadChargesRef.current) {
                                                        // Small timeout to ensure state updates have completed
                                                        setTimeout(() => reloadChargesRef.current(), 100);
                                                    }
                                                }}
                                                disabled={isApplyBids || isAdditionalBooking && activeTab !== "OCEAN_FCL" ? true : false}
                                                >
                                                <i className="bx bx-package mx-1"></i>FCL
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                href="#"
                                                className={classnames({
                                                    "active px-3 py-2": activeTab === "LCL",
                                                    "px-3 py-2": activeTab !== "LCL"
                                                })}
                                                onClick={() => {
                                                    dispatch({ type: QUOTE_MODAL_INITIAL });
                                                    setActiveTab("LCL");
                                                    dispatch({ type: INSTANT_RATE_ACTIVE_TAB_TYPE, payload: { main: "international", sub: "LCL" } });
                                                    dispatch({ type: ADD_OBJECT_INSTANT_SEARCH, payload: 'shipment_details' });
                                                    // Call reloadCharges function if available

                                                }}
                                                disabled
                                            >
                                                <i className="bx bx-package mx-1"></i>LCL
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                href="#"
                                                className={classnames({
                                                    "active px-3 py-2": activeTab === "AIR",
                                                    "px-3 py-2": activeTab !== "AIR"
                                                })}
                                                disabled={isApplyBids || isAdditionalBooking && activeTab !== "AIR" ? true : false}
                                                onClick={() => {
                                                    dispatch({ type: QUOTE_MODAL_INITIAL });
                                                    setActiveTab("AIR");
                                                    dispatch({ type: GET_AIR_LOCATION_TYPE });
                                                    dispatch({ type: INSTANT_RATE_ACTIVE_TAB_TYPE, payload: { main: "international", sub: "intl_Air" } });
                                                    dispatch({ type: ADD_OBJECT_INSTANT_SEARCH, payload: 'shipment_details' });
                                                    if (airReloadChargesRef.current) {
                                                        // Small timeout to ensure state updates have completed
                                                        setTimeout(() => airReloadChargesRef.current(), 100);
                                                    }
                                                }}>

                                                <i className="bx bx-rocket mx-1"></i>AIR
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="OCEAN_FCL">
                                        <div className="create_sales_search_forms">
                                            <div className="row">
                                                {initialSetupComplete && activeTab === "OCEAN_FCL" ? (
                                                    <ShippingQuotationForm
                                                        tabName={"FCL"}
                                                        quotation={quotationData}
                                                        isLoading={false}
                                                        setPreviewModal={setPreviewModal}
                                                        QuoteModalHandler={QuoteModalHandler}
                                                        toggleRightCanvas={toggleRightCanvas}
                                                        reloadChargesRef={reloadChargesRef}
                                                    />
                                                ) : (
                                                    <div className="col-12 text-center">
                                                        <div className="py-4">Loading...</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tabId="LCL">
                                        <div className="create_sales_search_forms">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p className="text-center py-5">LCL content will go here</p>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane tabId="AIR">
                                        <div className="create_sales_search_forms">
                                            <div className="row">
                                                {initialSetupComplete && activeTab === "AIR" ? (
                                                    <AirQuotationForm
                                                        tabName={"intl_Air"}
                                                        quotation={quotationData}
                                                        isLoading={false}
                                                        setPreviewModal={setPreviewModal}
                                                        QuoteModalHandler={QuoteModalHandler}
                                                        toggleRightCanvas={toggleRightCanvas}
                                                        airReloadChargesRef={airReloadChargesRef}
                                                    />
                                                ) : (
                                                    <div className="col-12 text-center">
                                                        <div className="py-4">Loading...</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                    </TourGuide>
                </Container>
            </div>

            <FilterSearchResult isApplyBids={isApplyBids} isRight={isRight} filterLoader={filterLoader} toggleRightCanvas={toggleRightCanvas} filterDetails={filterDetails} setfilterDetails={setfilterDetails} applyFilterHandler={applyFilterHandler} clearValueHandler={clearValueHandler} carriersList={carriersList} />
            {previewModal && <PreviewQuotationModal isEditDisplay={false} previewModal={previewModal} previewModalHand={previewModalHand} setPreviewModal={setPreviewModal} QuoteModalHandler={QuoteModalHandler} />}
        </>
    )
}

export default CreateSmartQuotation;
